<template>
  <div class="product-video-dialog">
    <custom-dialog
      width="480px"
      :title="model.title"
      :visible="visible"
      v-on="$listeners"
    >
      <div class="dialog-body">
        <div class="product" v-if="seeType==='product'">
          <!-- 用户信息 -->
          <div class="content-box product-box" >
            <div class="video" v-if="productInfo.productVedio">
              <video :src="productInfo.productVedio" autoplay controls>
                {{$t('training_product_video_dialog.ndllqbzcvideobf')}}
              </video>
              <!-- <i class="icon icon-zanting"></i> -->
            </div>
            <img v-else :src="productInfo.productAtlas" alt="">
          </div>
          <div class="tutorial-box" v-if="productTrainingList.length">
            <h2>{{$t('training_product_video_dialog.shi_yong_zhi_nan')}}</h2>
            <ul>
              <li v-for="(item,i) in productTrainingList" :key="i" @click="trainingDetails(item.trainingId)">
                <div class="cover-picture">
                  <img :src="item.trainingIcon" alt="">
                  <p>{{item.trainingName}}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="training" v-if="seeType==='training'">
          <div class="content-box">
            <div class="video" v-if="trainingInfo.trainingVedio">
              <video :src="trainingInfo.trainingVedio" ref="trainingVedio" autoplay controls loop @timeupdate="updateCurrentTime">
                {{$t('training_product_video_dialog.ndllqbzcvideobf')}}
              </video>
              <!-- <i class="icon icon-zanting"></i> -->
            </div>
            <img v-else :src="trainingInfo.trainingIcon" alt="">
          </div>
          <div class="training-box">
            <h2>
              <!-- 日常保养 -->
              {{trainingInfo.trainingName}}
            </h2>
            <ul>
              <li v-for="(item,i) in trainingNodeList" :key="i">
                <div class="node-item"  @click="setCurrentTime(item.startTime)" :class="{paly:item.startTime<=trainingCurrentTime && item.endTime>trainingCurrentTime}">
                  <h3>
                    <span class="inner">
                       {{item.nodeName}}
                    </span>
                    <i class="icon icon-zanting"  v-if="item.startTime<=trainingCurrentTime && item.endTime>trainingCurrentTime"></i>
                    <span class="time" v-else>
                      {{(item.endTime-item.startTime) | msToHours}}
                    </span>

                  </h3>
                  <p>{{item.nodeDesc}}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="backProduct" v-if="data.seeType === 'product' && seeType==='training'">{{
          $t('Common.com_back')
        }}</el-button>
        <el-button

          @click="closeDialog"
          >{{ $t('Common.com_close') }}
        </el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    data: [String, Object, Array],
    model: {
      type: Object,
      default() {
        return {
          type: '', // add、edit
          title: ''
        };
      }
    }
  },
  data() {
    return {
      visible: false,
      // 产品
      productInfo: {},
      productTrainingList: [],
      seeType: 'product',
      // 教程
      trainingId: '',
      nodeList: [],
      trainingInfo: {},
      trainingName: '',
      trainingNodeList: [],
      trainingCurrentTime: 0,
      currentTimeFlag: true
    };
  },
  mounted() {
    this.initDialog();

  },
  filters: {
    msToHours: function (mss) {
      if (!mss) {
        return '';
      }
      const hours = Math.floor(mss / (60 * 60)) < 10 ? `0${Math.floor(mss / (60 * 60))}` : Math.floor(mss / (60 * 60));
      const minutes = Math.floor((mss % (60 * 60)) / 60) < 10 ? `0${Math.floor((mss % (60 * 60)) / 60)}` : Math.floor((mss % (60 * 60)) / 60);
      const ms = Math.floor((mss % (60))) < 10 ? `0${Math.floor((mss % (60)))}` : Math.floor((mss % (60)));
      return `${hours}:${minutes}:${ms}`;
    }
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      if (this.data.seeType === 'product') {
        this.getProductDetail();
      } else if (this.data.seeType === 'training') {
        this.trainingDetails(this.data.trainingId);
      }
    },
    // 获取详情
    getProductDetail: function () {
      this.seeType = 'product';
      this.$getJSON(apis.tmsProductInfo, { productId: this.data.productId, isShowTraining: 1 }).then((res) => {
        this.productInfo = res.data;
        this.productTrainingList = res.data.trainings || [];
        // this.$setFormatData(this.form, data);
      }
      );
    },
    // 章节详情
    trainingDetails: function (trainingId) {
      this.seeType = 'training';
      this.trainingId = trainingId;
      this.$getJSON(apis.tmsProductTrainingInfo, {
        trainingId: this.trainingId
      }).then((res) => {
        this.trainingInfo = res.data;
        this.trainingName = res.data.trainingName;
        this.trainingNodeList = res.data.nodes || [];
      });
    },
    // 返回
    backProduct: function () {
      this.seeType = 'product';
    },
    // 播放时间变化
    updateCurrentTime: function (e) {
      if (!this.currentTimeFlag) {
        return;
      }
      // 首次进入能执行
      this.currentTimeFlag = false;
      // 每秒刷新
      setTimeout(() => {
        this.trainingCurrentTime = parseInt(e.target.currentTime, 10);
        this.currentTimeFlag = true;
      }, 1000);
    },
    // 点击章节播放时间
    setCurrentTime: function (time) {
      this.$refs.trainingVedio.currentTime = time;
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 200);
    }
  }
};
</script>

<style lang="scss">
.product-video-dialog {
  .dialog-body {
    padding: 0px !important;
  }
  .content-box{
    .video{
      width:480px;
      height: 250px;
      background-color: rgba(0, 0, 0, 1);
      video{
        height: 100%;
        width: 100%;
        display: block;
      }
    }
  }
  .product-box{
    img{
      width: 100%;
      height: auto;
    }
  }
  .tutorial-box{
    padding: 24px;
    margin: 0;
    h2{
      text-align: center;
      margin: 8px 0 24px 0;
      height:25px;
      font-size:18px;
      font-weight:bold;
      color:rgba(51,51,51,1);
      line-height:25px;
    }
    ul{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      li{
        // margin-right: 17px;
        cursor: pointer;
        .cover-picture{
          padding: 10px 10px 0 10px ;
          width: 208px;
          img{
            width: 188px;
            height: 106px;
          }
          p{
            text-align: center;
            line-height: 39px;
            height:39px;
            font-size:14px;
            font-weight:bold;
            color:rgba(51,51,51,1);
          }
        }
        &:nth-child(even){
          margin: 0;
        }
      }
    }
  }
  .training-box{
    padding: 19px 24px 68px;
    background:rgba(245,245,245,1);
    h2{
      text-align: center;
      line-height: 47px;
      height:47px;
      background:rgba(255,255,255,1);
      font-size:15px;
      font-weight:bold;
      color:rgba(33,33,33,1);
    }
    ul{
       display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      li{
        margin-top: 10px;
        cursor: pointer;
        div{
          width: 211px;
          padding:9px 12px;
          background-color: #fff;
          h3{
            display:flex;
            align-content: center;
            .inner{
              font-size:15px;
              font-weight:bold;
              color:rgba(33,33,33,1);
              line-height:25px;
              flex: 1;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            }
            span,i{
              font-size:12px;
              font-weight:400;
              color:rgba(204,204,204,1);
              line-height:17px;
              float: right;
              align-self: center;
            }
            i{
              color:rgba(255, 255, 255, 1) ;
            }
          }
          p{
            font-size:12px;
            font-weight:400;
            color:rgba(204,204,204,1);
            line-height:17px;
          }
        }
      }
      li{
        div.paly{
          background:rgba(102,102,102,1);
          h3 .inner,p{
            color:rgba(255,255,255,0.95);
          }
        }
      }
    }
  }
}
</style>
